import React, { ReactElement } from 'react';
import TableCell from '../table-cell/table-cell.component';
import useStylesTableCellCheckbox from './table-cell-checkbox.styles';

const TableCellCheckbox: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isSticky,
    isStickyLeft,
    isStickyGroupLeft,
    children,
  } = props;

  const { classes } = useStylesTableCellCheckbox();

  return (
    <TableCell
      isSticky={isSticky}
      isStickyLeft={isStickyLeft}
      isStickyGroupLeft={isStickyGroupLeft}
      className={classes.tableCellCheckbox}
    >
      {children}
    </TableCell>
  );
});

export default TableCellCheckbox;
